import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { throttleTime } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
  
  @Directive({
    selector: '[appThrottleClick]'
  })
  export class ThrottleClickDirective implements OnInit, OnDestroy {
    @Input() 
    throttleTime  = 500;
  
    @Output() 
    throttleClick = new EventEmitter();
  
    private clicks = new BehaviorSubject<any>({});
    private subscription = this.clicks.asObservable();
  
    constructor() { }
  
    ngOnInit() {
      this.clicks.pipe(
        throttleTime(this.throttleTime )
      ).subscribe(e => this.throttleClick.emit(e));
    }
  
    ngOnDestroy() {
      this.clicks.unsubscribe();
    }
  
    @HostListener('click', ['$event'])
    clickEvent(event) {
      event.preventDefault();
      event.stopPropagation();
      this.clicks.next(event);
    }
  }